import { render, staticRenderFns } from "./MyLogworks.vue?vue&type=template&id=432a365b&scoped=true&"
import script from "./MyLogworks.vue?vue&type=script&lang=ts&"
export * from "./MyLogworks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a365b",
  null
  
)

export default component.exports